export default (t) =>
  `${t}JzZXNzaW9uS2V5IjoiMjY5MGVmMmYtZjZmMS00.dhvbsdkvhsbvGDGDwf9fhyw`;
